module.exports = __webpack_public_path__ + "static/media/class-placeholder.2999d9af.svg";